import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import combineReducers from './combineReducers';
import clientMiddleware from './clientMiddleware';
import ApiClient from '../../helpers/ApiClient';

export const history = createBrowserHistory();
const apiClient = new ApiClient();

const initialState = {};

const middleware = [
	clientMiddleware(apiClient),
	thunk,
	routerMiddleware(history)
];
const enhancers = [];

const composeEnhancers = (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
	? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const composedEnhancers = composeEnhancers(
	applyMiddleware(...middleware),
	...enhancers
);

const store = createStore(
	combineReducers,
	initialState,
	composedEnhancers
);

store.client = apiClient;

export default store;
